import PropTypes from 'prop-types';
import './styles/horizontalEmptyStateStyles.css';

const HorizontalEmptyStateTemplate = ({ children, ...rest }) => (
  <div className="horizontal-empty-state-template" {...rest}>
    {children}
  </div>
);

HorizontalEmptyStateTemplate.propTypes = {
  children: PropTypes.node.isRequired,
};

export default HorizontalEmptyStateTemplate;
